const TOKEN_KEY = "zTaskAuthToken";
const USER_KEY = "zTaskUserDetails";

export function readAuthUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    const user = raw ? JSON.parse(raw) : null;
    const token = localStorage.getItem(TOKEN_KEY);
    let claims = {};
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
        claims = payload.claims || {};
      } catch {
        claims = {};
      }
    }
    const roleName = (
      user?.role?.name ||
      (typeof user?.role === "string" ? user.role : "") ||
      claims.roles ||
      ""
    )
      .toString()
      .toUpperCase();
    const permissions = Array.isArray(user?.role?.permissions)
      ? user.role.permissions.map((p) => (typeof p === "string" ? p : p.title)).filter(Boolean)
      : [];
    return { user, roleName, permissions, isSuperAdmin: roleName === "SUPER_ADMIN" };
  } catch {
    return { user: null, roleName: "", permissions: [], isSuperAdmin: false };
  }
}
